var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.182,
    height: 19.305,
    viewBox: "0 0 17.182 19.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173014",
    "data-name": "Group 173014",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification_2_",
    "data-name": "notification (2)",
    transform: "translate(0 0.763)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARC_276_",
    transform: "translate(1.968 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171681",
    "data-name": "Group 171681",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M24.579,11.284a.662.662,0,0,1-.662-.662,5.3,5.3,0,1,0-10.6,0,.662.662,0,1,1-1.324,0,6.622,6.622,0,1,1,13.244,0A.662.662,0,0,1,24.579,11.284Z",
    transform: "translate(-11.997 -4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_277_",
    transform: "translate(13.888 10.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171682",
    "data-name": "Group 171682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M48.66,40.318a.662.662,0,0,1,0-1.324,1.34,1.34,0,0,0,.883-2.312.662.662,0,0,1,.883-.987,2.664,2.664,0,0,1-1.766,4.623Z",
    transform: "translate(-47.998 -35.526)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_455_",
    transform: "translate(13.888 5.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171683",
    "data-name": "Group 171683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M48.66,24.842A.662.662,0,0,1,48,24.18V22.662a.662.662,0,1,1,1.324,0V24.18A.662.662,0,0,1,48.66,24.842Z",
    transform: "translate(-47.998 -22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_278_",
    transform: "translate(13.888 7.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171684",
    "data-name": "Group 171684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M49.984,30.869a.659.659,0,0,1-.441-.169A4.641,4.641,0,0,1,48,27.245a.662.662,0,1,1,1.324,0,3.316,3.316,0,0,0,1.1,2.468.662.662,0,0,1-.442,1.156Z",
    transform: "translate(-47.998 -26.583)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_456_",
    transform: "translate(1.968 5.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171685",
    "data-name": "Group 171685",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M12.66,24.842A.662.662,0,0,1,12,24.18V22.662a.662.662,0,1,1,1.324,0V24.18A.662.662,0,0,1,12.66,24.842Z",
    transform: "translate(-11.998 -22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_279_",
    transform: "translate(0.644 7.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171686",
    "data-name": "Group 171686",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M8.661,30.868a.662.662,0,0,1-.442-1.156,3.315,3.315,0,0,0,1.1-2.468.662.662,0,1,1,1.324,0A4.641,4.641,0,0,1,9.1,30.7a.658.658,0,0,1-.441.169Z",
    transform: "translate(-7.998 -26.582)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_280_",
    transform: "translate(4.617 13.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171687",
    "data-name": "Group 171687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M23.971,50.634A4.026,4.026,0,0,1,20,46.661a.662.662,0,1,1,1.324,0,2.649,2.649,0,1,0,5.3,0,.662.662,0,1,1,1.324,0,4.026,4.026,0,0,1-3.973,3.973Z",
    transform: "translate(-19.998 -45.999)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_281_",
    transform: "translate(0 10.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171688",
    "data-name": "Group 171688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M8.684,40.319A2.664,2.664,0,0,1,6.918,35.7a.662.662,0,0,1,.883.987A1.34,1.34,0,0,0,8.684,39a.662.662,0,1,1,0,1.324Z",
    transform: "translate(-6.053 -35.528)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_457_",
    transform: "translate(1.968 13.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171689",
    "data-name": "Group 171689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M24.58,47.323H12.66a.662.662,0,0,1,0-1.324H24.58a.662.662,0,0,1,0,1.324Z",
    transform: "translate(-11.998 -45.999)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_171691",
    "data-name": "Group 171691",
    transform: "translate(9.458 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M7.829,7.06a3.616,3.616,0,1,1-3.616,3.616A3.616,3.616,0,0,1,7.829,7.06Z",
    transform: "translate(-4.213 -7.06)",
    fill: "#e57339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M-.36-1.165v-.377L.847-2.688a1.616,1.616,0,0,0,.226-.252.657.657,0,0,0,.1-.2.71.71,0,0,0,.024-.176.391.391,0,0,0-.143-.323A.661.661,0,0,0,.63-3.755a1,1,0,0,0-.4.078.812.812,0,0,0-.31.239l-.395-.3A1.169,1.169,0,0,1,0-4.113a1.662,1.662,0,0,1,.675-.132,1.436,1.436,0,0,1,.575.106.851.851,0,0,1,.377.3.808.808,0,0,1,.132.464,1.124,1.124,0,0,1-.039.293,1.034,1.034,0,0,1-.148.306,2.323,2.323,0,0,1-.317.36L.222-1.429.1-1.642H1.879v.477Z",
    transform: "translate(2.871 6.194)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.cc462ac6d768135429a1b274636ac12e.svg";
export { ForwardRef as ReactComponent };